import styled from "styled-components";
import {FaLongArrowAltRight} from "react-icons/fa";
function OptionFunction(props){
    return(
        <Option className="option">
            <label className="formOptionInput">
                <input
                    id="inputRadio"
                    name="formService"
                    type="radio"

                />
                <span className="checkmark"></span>
                <span className="checkmark-2"></span>
            </label>
            <OptionTitle>
                {props.title}
                <OptionDescription>
                    {props.description}
                </OptionDescription>
                <a href={props.link}>
                <OptionDescriptionLink>
                    <div>
                        Zjistit více
                    </div>
                    <FaLongArrowAltRight />
                </OptionDescriptionLink>
                </a>
            </OptionTitle>
        </Option>
        );
}
function FormBlocks(props){
    return(
        <div>
            <FormTitle>
                {props.title}
            </FormTitle>
            <FormInput>
                <input
                    name={props.name}
                    type={props.type}
                    required
                />
            </FormInput>
        </div>
    );
}
function Contact(){
    return(
        <Block className="blocks-padding">
            <div className="layout">
                <Text className="animate">
                    Změňte své webové řešení k lepšímu
                </Text>
                <Title className="h-1 title-padding-1-bottom">
                    kontaktujte nás!
                </Title>
                <form>
                    <Flex>
                    <FormOptions>
                        <OptionFunction title="Webový design" description="UX/UI design" link="#"/>
                        <OptionFunction title="Webová aplikace" description="Protrhnout díru ve světě" link="#"/>
                        <OptionFunction title="E-shop" description="Komplexní řešení e-shopů" link="#"/>
                        <OptionFunction title="Prezentační web" description="Protrhnout díru ve světě" link="#"/>
                    </FormOptions>
                    <FormContact>
                        <div className="layout-contact">
                            <div className="h-1 title-padding-2-bottom title-contact">
                            Pár informací o Vás
                            </div>
                            <form>
                                <FormBlocks title="Jméno a příjmení" name="username" type="text" />
                                <FormBlocks title="E-mail" name="e-mail" type="text" />
                                <FormBlocks title="Telefon" name="telephone" type="text" />
                                <input type="submit" className="submitForm"/>
                            </form>
                        </div>
                    </FormContact>
                </Flex>
                </form>
            </div>
        </Block>
    );
}

const Block = styled.div`
  background-color:var(--main-color);
  color:white;
`;
const Title = styled.div`
  text-align: center;
  font-size: 64px;
  font-weight: bold;
  padding-top:20px;
`;
const Text = styled.div`
  text-align: center;
  font-size: 24px;
`;
const Flex = styled.div`
  display: flex;
  background-color: #B82A2F;
  padding: 60px;
  border-radius: 20px;
  @media only screen and (max-width: 1399px){
    display:block;
  }
  @media only screen and (max-width: 699px){
    background-color: transparent;
    padding: 0;
  }
`;
const FormOptions = styled.div`
  flex:2;
  display:flex;
  flex-wrap: wrap;
  gap:40px;
  @media only screen and (max-width: 800px){
    display:block;
  }
`;
const Option = styled.div`
  position:relative;
  display: flex;
  justify-content: center;
  align-items: center;

  transition:0.3s;
  
  background-color:white;
  border-radius:20px;  
  width: 300px;
  height: 260px;
  
  .checkmark{
    position: absolute;
    
    width: 30px;
    height: 30px;
    background-color: #eee;
    border-radius: 50%;

    display:flex;
    justify-content: center;
    align-items: center;
  }
  .checkmark-2{
    position: absolute;
    top: -30px;
    left: -240px;
    width: 300px;
    height: 260px;
    background-color: #eee;
    border-radius: 20px;
    opacity: 0;
    
  }
  .formOptionInput input:checked .checkmark{
    display: inline-block;
  }
  .formOptionInput{
    position:absolute;
    top:30px;
    right:30px;
    
    width: 30px;
    height: 30px;
    border-radius: 50%;
    
    display:flex;
    justify-items: center;
    align-items: center;
  }
  .formOptionInput input:checked ~ .checkmark {
    background-color: var(--main-color);
  }
  .formOptionInput input:checked ~ .checkmark-2 {
    border:1px solid red;
  }
  .formOptionInput input:checked ~ .checkmark:after {
    display:block;
  }
  .checkmark:after {
    content:"";
    position:absolute;
    
    
    width:14px;
    height:14px;
    background-color:white;
    border-radius:50%;
    
    display: none;
  }
  &:hover {
    scale:1.04;
  }
  @media only screen and (min-width: 940px) and (max-width: 1399px){
    flex: 0 0 47%;
  }
  @media only screen and (min-width: 800px) and (max-width: 940px){
    flex: 0 0 44%
  }
  @media only screen and (max-width: 799px){
    width: 100%;
    margin-bottom: 20px;
  }
`;
const OptionTitle = styled.div`
  color:black;
  font-weight: bold;
  font-size:24px;
  text-align: center;
`;
const OptionDescription = styled.div`
  font-weight: normal;
  font-size:17px;
`;
const OptionDescriptionLink = styled.div`
  position: absolute;

  bottom: 30px;
  left: 50%;
  transform: translate(-50%, -50%);

  display: flex;
  justify-content: center;
  align-items: center;

  color: #6e6e6e;
  font-size: 18px;

  div {
    margin-right: 8px;
  }

  svg {
    font-size: 20px;
  }
`;
const FormContact = styled.div`
  flex:1.1;
  position:relative;
  
  margin:0 auto;
  width:80%;
  
  background-color:white;
  border-radius:20px;
  
  color:black;
  .title-contact{
    @media only screen and (max-width: 1399px){
      text-align: center;
    }
  }
  .submitForm{
    
    bottom:0;
    
    width:100%;
    background-color:var(--main-color);
    padding:20px 0 20px 0;
    border:none;
    border-radius:10px;
    
    color:white;
    font-size:18px;
    cursor:pointer;
    @media only screen and (max-width: 1399px){
      padding:15px 0 15px 0;
    }
  }
  .layout-contact{
    padding:40px;
  }
  @media only screen and (max-width: 1399px){
    margin-top:50px;  
    width: 100%;
  }
`;
const FormTitle = styled.div `
  font-size:17px;
  margin-bottom:10px
`;
const FormInput = styled.div`
  margin-bottom:20px;
  padding: 10px 24px 10px 24px;
  background-color: #eee;
  border-radius: 10px;
  input{
    font-size:18px;
    
    height: 40px;
    width: 100%;
    background-color:#eee;
    border-radius: 8px;
    border: none;
    outline:none;
  }
  @media only screen and (max-width: 1399px){
    input{
      height: 30px;
    }
  }
`;
export default Contact;